import { render } from "./Show.vue?vue&type=template&id=1b1f4f03&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=1b1f4f03&scoped=true&lang=css"

import exportComponent from "/data/gitlab-runner/builds/hunterretail/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1f4f03"]])

export default __exports__